export enum IntervenantFunction {
    ASSISTANTE_OPERATION = 'AP',
}